<template>
  <div v-if="isInitial">
    <div class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
      <div class="container">
        <article>
          <div>
            <div class="section fixed-bottom-wrapper white-panel pt28 pb184 mb2p">
              <p class="mb8 mt8">
                <img src="/lib/images/img_CCTop_banner_syaken.png" class="w100p" alt="コミっと車検">
              </p>
              <p class="fs13 font-weight-bold color-red2 text-center mb4">
                誠に申し訳ありませんが、ただいまメンテナンス<br>中につき、ご利用いただくことが出来ません。<br>お時間をあけてから再度アクセスをお願い致します。
              </p>
                <div class="bg-gray1 pd12">
                  <p class="mb0 fs13">お客様のお気に入り店舗での受付となります。
                    外車や年式の古い車両はご利用いただけません。
                    ご利用の詳細は<a id="aboutConditions" v-on:click='modalOpen($event)'>こちら</a>をご覧ください。<br>
                    特定商取引にかかわる表記については<a href="#" v-on:click="toAgreement()">こちら</a></p>
                </div>
            </div>
          </div>
        </article>
      </div>
      <div class="modal_overlay">
        <div class="modal_container">
          <div class="modal_body radius8 pd24 mt8p mb8p">
            <div v-if="aboutConditions">
              <h2 class="fs18 mb8">対象車両の条件</h2>
              <p class="fs14 mb16">・自家用の乗用車（事業用や貨物車両は除く）<br>
                ・普通/軽/小型（大型特殊車両は除く）<br>
                ・国産の8メーカー（外車やその他メーカーは除く）<br>
                －トヨタ、ホンダ、日産、ダイハツ、スズキ、三菱、マツダ、スバル<br>
                ・初度登録年月が車検実施日から遡って20年未満<br>
                ・走行距離が20万km以下
              </p>
              <h2 class="fs18 mb8">ご利用の注意</h2>
              <p class="fs14 mb16">・予約は1端末につき1台まで可能です。2台目以降は車検完了後または別の端末からご予約ください。<br>
                ・機種変更や端末紛失、再インストールによりご予約情報がアプリから確認できなくなった場合は、ご予約のSSまで電話でお問い合わせください。</p>
            </div>
            <div v-if="aboutInspected">
              <p class="fs14 mb16">機種変更や端末紛失の際は、<br>
                車検をご予約のSSまで電話にてご連絡下さい。</p>
            </div>
            <button v-on:click="modalClose()" class="button fs16 w100p mt16 mb0 pd16 radius200">閉じる</button>
          </div>
          <!-- /.modal_body -->
        </div>
        <!-- /.modal_container -->
      </div>
    </div>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
</template>

<script>
import Agreement from '@/views/v3/Agreement.vue'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data () {
    return {
      modalActive: false,
      aboutConditions: false,
      aboutInspected: false,
      currentState: IS_INITIAL
    }
  },
  methods: {
    modalOpen (about) {
      window.modalHeight = window.pageYOffset
      window.scrollTo(0, 0)
      this.modalActive = true
      if (about.target.id === 'aboutConditions') {
        this.aboutConditions = true
        this.nativePVset('SHAKEN_TAISHO')
        // [eventTrack] カーケアTOP 車検対象車種 タップ
        this.nativeEVENTSet('ShakenButton', 'MOVED_SHAKEN_TAISHO', 'TAP')
      } else if (about.target.id === 'aboutInspected') {
        this.aboutInspected = true
      }
    },
    modalClose () {
      window.scrollTo(0, window.modalHeight)
      this.modalActive = false
      this.aboutConditions = false
      this.aboutInspected = false
    },
    appChangeMySs () {
      // 戻るボタンを非活性にする
      this.appDisplayBack(false)
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.changeMySs()
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.changeMySs.postMessage('')
      }
      // [eventTrack] カーケアTOP マイSS変更 タップ
      this.nativeEVENTSet('ShakenButton', 'MOVED_SSSENTAKU', 'TAP')
    },
    toInitial () {
      this.currentState = IS_INITIAL
      this.appDisplayBack(true)
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.appDisplayBack(true)
      this.nativeEVENTSet('ShakenButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    }
  },
  computed: {
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    }
  },
  components: {
    Agreement
  }
}
</script>
